import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, MenuItem, TableContainer, TableHead, Table, TableRow, styled, TableBody, Chip, IconButton } from "@mui/material";
import { useParams } from "react-router-dom";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { RxCross2 } from "react-icons/rx";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        padding: "10px",
        fontSize: 16,
        fontFamily: "Outfit, sans-serif",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: "10px",
        fontFamily: "Outfit, sans-serif",
    },
}));

const rows = [
    {
        id:1,
        category: "Infra",
        line: "Boundary Wall",
        baseLineCost: "8.22",
        bcws: "3.25",
        earnedCost: "1.79",
        variance: "1.46",
    },
    {
        id:2,
        category: "Infra",
        line: "Land Development",
        baseLineCost: "22.99",
        bcws: "11.41",
        earnedCost: "6.52",
        variance: "4.90",
    },
    {
        id:3,
        category: "Infra",
        line: "Drainage System",
        baseLineCost: "1.13",
        bcws: "0.00",
        earnedCost: "0.00",
        variance: "0.00",
    },
    {
        id:4,
        category: "Commercial Zone",
        line: "Hotel",
        baseLineCost: "79.86",
        bcws: "4.5",
        earnedCost: "0.52",
        variance: "79.42",
    },
    {
        id:4,
        category: "Commercial Zone",
        line: "Rail Yard Terminal",
        baseLineCost: "20.48",
        bcws: "0.41",
        earnedCost: "0",
        variance: "0.41",
    },
    {
        id:5,
        category: "Commercial Zone",
        line: "Domestic Container Yard (DCT)",
        baseLineCost: "3.57",
        bcws: "0.28",
        earnedCost: "0.00",
        variance: "0.28",
    },
    {
        id:6,
        category: "Commercial Zone",
        line: "Inland Container (ICD)",
        baseLineCost: "12.67",
        bcws: "1.61",
        earnedCost: "0.73",
        variance: "0.88",
    },
        {
        id:7,
        category: "Commercial Zone",
        line: "Bonded Warehouse",
        baseLineCost: "4.56",
        bcws: "9.34",
        earnedCost: "0.28",
        variance: "9.06",
    },
    {
        id:8,
        category: "Commercial Zone",
        line: "Admin & Custom Building",
        baseLineCost: "7.08",
        bcws: "2.99",
        earnedCost: "0.58",
        variance: "2.41",
    },
    {
        id:9,
        category: "Commercial Zone",
        line: "Canteen",
        baseLineCost: "2.23",
        bcws: "0.82",
        earnedCost: "0.09",
        variance: "0.73",
    },
    {
        id:10,
        category: "Commercial Zone",
        line: "Warehousing -1",
        baseLineCost: "46.67",
        bcws: "30.30",
        earnedCost: "6.82",
        variance: "23.48",
    },
    {
        id:11,
        category: "Commercial Zone",
        line: "Internal Roads & Circulation Area",
        baseLineCost: "27.64",
        bcws: "2.21",
        earnedCost: "0.95",
        variance: "1.26",
    },
    {
        id:12,
        category: "Commercial Zone",
        line: "Truck & Vehicle Parking",
        baseLineCost: "3.30",
        bcws: "1.07",
        earnedCost: "0.00",
        variance: "1.07",
    },
    {
        id:13,
        category: "Commercial Zone",
        line: "Design & Drawing",
        baseLineCost: "2.32",
        bcws: "6.49",
        earnedCost: "7.5",
        variance: "0.00",
    },
    {
        id:14,
        category: "Common Infrastructure Facilities",
        line: "MEP_Civil",
        baseLineCost: "2.32",
        bcws: "0.00",
        earnedCost: "0.00",
        variance: "0.00",
    },
    {
        id:15,
        category: "Common Infrastructure Facilities",
        line: "MEP_Equip/other services/Finishing/Misc.",
        baseLineCost: "37.41",
        bcws: "8.03",
        earnedCost: "10.93",
        variance: "0.00",
    },
    {
        id:16,
        category: "Common Infrastructure Facilities",
        line: "Landscaping and Horticulture",
        baseLineCost: "5.15",
        bcws: "0.03-",
        earnedCost: "0.25",
        variance: "0.00",
    },
    {
        id:17,
        category: "Common Infrastructure Facilities",
        line: "Petrol Pump",
        baseLineCost: "1.16",
        bcws: "0.00",
        earnedCost: "0.00",
        variance: "0.00",
    },
    {
        id:18,
        category: "Common Infrastructure Facilities",
        line: "Weigh bridge",
        baseLineCost: "1.37",
        bcws: "0.13",
        earnedCost: "0.39",
        variance: "0.00",
    },
    {
        id:19,
        category: "Common Infrastructure Facilities",
        line: "Gate + Security",
        baseLineCost: "0.79",
        bcws: "0.00",
        earnedCost: "0.00",
        variance: "0.00",
    },
];

const BreakdownTable = (props) => {
    const { open, handleClose } = props;
    const { projectId } = useParams();

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}><Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    Cost Breakdown Table
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow
                                sx={{
                                    "& th": {
                                        fontWeight: 600,
                                        fontSize: 13,
                                        color: "#6b7280",
                                        borderBottom: "1px solid #e5e7eb",
                                        whiteSpace: "nowrap",
                                    },
                                }}
                            >
                                <StyledTableCell>Category</StyledTableCell>
                                <StyledTableCell>Line</StyledTableCell>
                                <StyledTableCell>Baseline Cost</StyledTableCell>
                                <StyledTableCell>BCWS</StyledTableCell>
                                <StyledTableCell align="right">Actual/Earned Cost</StyledTableCell>
                                <StyledTableCell align="right">Variance</StyledTableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {rows.map((row, index) => (
                                <TableRow
                                    key={row.id}
                                    sx={{
                                        "& td": {
                                            fontSize: 13,
                                            borderBottom: "1px solid #f3f4f6",
                                            paddingY: 1.25,
                                        },
                                        // light zebra effect
                                        backgroundColor:
                                            index % 2 === 0 ? "#ffffff" : "#f9fafb",
                                    }}
                                >
                                    <StyledTableCell>{row.category}</StyledTableCell>
                                    <StyledTableCell>{row.line}</StyledTableCell>
                                    <StyledTableCell>{row.baseLineCost}</StyledTableCell>
                                    <StyledTableCell align="right">{row.bcws}</StyledTableCell>
                                    <StyledTableCell align="right">{row.earnedCost}</StyledTableCell>
                                    <StyledTableCell align="right">{row.variance}</StyledTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
        </Dialog>
    );
};

export default BreakdownTable;
